import { useQuery } from "@tanstack/react-query";

import { getUserInfo } from "shared/api/AuthApi";

/**
 * 로그인한 관리자 본인의 프로필(/appUsers/myProfile)을 앱 전역에서 공유하는 훅.
 *
 * 같은 queryKey(["myProfile"])를 쓰는 모든 소비자(헤더·사이드바·라우트 가드 등)가
 * 하나의 요청/캐시를 공유하므로, 페이지마다 개별로 호출하던 getUserInfo를 일원화한다.
 * 응답에는 name·email·auth(권한 등급)·id가 포함된다.
 */
export const useMyProfile = () =>
  useQuery({
    queryKey: ["myProfile"],
    queryFn: getUserInfo,
    enabled: localStorage.getItem("admintoken") !== null,
    staleTime: 5 * 60 * 1000,
  });

/**
 * 로그인한 관리자 본인의 권한 등급(auth). 1:일반 2:일반관리자 3:총학관리자 4:마스터관리자.
 * 프로필이 확정되기 전(로딩·미로그인)에는 0을 반환한다(fail-closed).
 */
export const useMyAuth = () => useMyProfile().data?.auth ?? 0;
